import '../Services.css';
import HeadImage from '../../../components/img/photos/services/pct.png'
import Headboard from '../../../components/services/Headboard';
import { Col, Container, Row } from 'react-bootstrap';
import ServiceCustomCard from '../../../components/services/ServiceCustomCard';
import BotonCustom from '../../../components/all/BotonCustom';
import CustomTitle from '../../../components/services/CustomTitle';
import NumberCustomCard from '../../../components/services/NumberCustomCard';


const Pct = () =>{
    const itemsUno=[
        {texto:'Asocia pagos huérfanos a órdenes de pago.'},
        {texto:'Configura reversas automatizadas de transferencias no exactas.'},
        {texto:'Realiza pagos de premios inidividuales o por archivo de lotes.'},
        {texto:'Gestión de agenda de contactos para pagos.'},
        {texto:'Validación automatizada de CUIT de destinatarios de pagos.'},
        {texto:'Configura descuentos transaccionales a modo de cargos por devoluciones o reembolsos de pagos por transferencias.'},
        {texto:'Llevar cuenta corriente de cobros y pagos en una misma pantalla.'}
    ]
    


    return (
        <div id='services' className='containerFluid'>

            <Headboard title={`Pagos con Transferencias`} subtitle={`Exclusivo sistema de gestión de cobros y pagos`} button={`Quiero mi PCT`} image={HeadImage}/>
            <Container className='container-body-2' style={{paddingTop:'80px', paddingBottom:'80px'}}>
            <Row>   
            <Col md={12}>
                    <ServiceCustomCard number='1' title={`Carga saldos, depósitos, cobros, pagos, premios, proveedores, etc.`} list={itemsUno}/><br/><br/>
                </Col>
                
                <Col md={12} className='text-center' data-aos="fade-up" data-aos-offset="50" data-aos-delay="200" data-aos-duration="1000"><br/><br/>
                    <BotonCustom text='Quiero mi PCT' tipo='blue'/><br/><br/>
                </Col>
                <Col md ={12} data-aos="fade-up" data-aos-offset="50" data-aos-delay="100" data-aos-duration="1000">
                    <CustomTitle title={`¿Cómo pagan tus clientes?`}/>
                </Col>
                <Col md ={12}>
                <Row>
                    <Col md={6}><NumberCustomCard number='1' title={`Genera la órden\nde pago.`}/></Col>
                    <Col md={6}><NumberCustomCard number='2' title={`Selecciona\npago con\ntransferencia`}/></Col>
                    <Col md={6}><NumberCustomCard number='3' title={`Ingresa en\nsu HomeBanking\ny hace la transferencia`}/></Col>
                    <Col md={6}><NumberCustomCard number='4' title={`Se registra\nel pago exitoso.`}/></Col>
                </Row>
                </Col>
                <Col md={12} className='text-center' data-aos="fade-up" data-aos-offset="50" data-aos-delay="200" data-aos-duration="1000"><br/><br/>
                    <BotonCustom text='Quiero mi PCT' tipo='blue'/><br/><br/>
                </Col>
            </Row>
            </Container>    
        
            
            
        </div>
    )
}

export default Pct